/* RUVAKLI · Medianoche Líquida — comportamiento mínimo, sin librerías */
(function () {
  'use strict';

  /* Entrada suave al llegar a viewport */
  function reveal() {
    var els = document.querySelectorAll('.rv-in:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Acordeón de preguntas */
  function faq() {
    document.querySelectorAll('.rv-faq__q').forEach(function (btn) {
      if (btn.dataset.rvBound) return;
      btn.dataset.rvBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.rv-faq__it');
        var panel = item.querySelector('.rv-faq__a');
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.rv-faq__it.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          o.querySelector('.rv-faq__a').style.maxHeight = null;
          o.querySelector('.rv-faq__q').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* Barra de compra: aparece al pasar el hero, se esconde al llegar al cierre */
  function bar() {
    var el = document.querySelector('.rv-bar');
    if (!el) return;
    var hero = document.querySelector('.rv-hero');
    var end = document.querySelector('.rv-close');
    var tick = false;
    function upd() {
      tick = false;
      var passed = hero ? (window.scrollY > hero.offsetTop + hero.offsetHeight - 120) : window.scrollY > 600;
      var atEnd = end ? (end.getBoundingClientRect().top < window.innerHeight * 0.85) : false;
      el.classList.toggle('is-on', passed && !atEnd);
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* Los vídeos son el argumento de venta: si el navegador bloquea el autoplay,
     se reintenta al primer gesto del usuario. Y solo se reproducen si están
     a la vista, para no gastar batería ni datos. */
  function videos() {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length) return;

    function tryPlay(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* bloqueado: reintento en el gesto */ });
    }

    vids.forEach(function (v) {
      v.muted = true;              // requisito para autoplay en todos los navegadores
      v.setAttribute('muted', '');
      v.playsInline = true;
      if (v.readyState >= 2) tryPlay(v);
      else v.addEventListener('loadeddata', function () { tryPlay(v); }, { once: true });
    });

    /* pausa lo que no se ve */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) tryPlay(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { threshold: 0.15 });
      vids.forEach(function (v) { io.observe(v); });
    }

    /* red de seguridad: al primer toque o scroll, arrancar lo visible */
    function kick() {
      vids.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) tryPlay(v);
      });
    }
    ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, kick, { once: true, passive: true });
    });
  }

  function init() { reveal(); faq(); bar(); videos(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* El editor de temas recarga secciones sueltas */
  document.addEventListener('shopify:section:load', init);
})();
